module.exports = __webpack_public_path__ + "img/top_bg3.0e6e5413.png";